import { render, staticRenderFns } from "./groupHonor.vue?vue&type=template&id=0d30f12d&scoped=true"
import script from "./groupHonor.vue?vue&type=script&lang=js"
export * from "./groupHonor.vue?vue&type=script&lang=js"
import style0 from "./groupHonor.vue?vue&type=style&index=0&id=0d30f12d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30f12d",
  null
  
)

export default component.exports